// extracted by mini-css-extract-plugin
export default {"vipRules":"vipRules_vipRules__ijetc","rules_title":"vipRules_rules_title__aW4Mq","rules_items":"vipRules_rules_items__A+rWG","item":"vipRules_item__jWBWO"};